function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import get from 'lodash/get';
import keys from 'lodash/keys';
import pick from 'lodash/pick';
import intersection from 'lodash/intersection';
import clone from 'lodash/clone';
import Ncs from '../index';
export default {
  namespaced: true,
  state: {
    // Possible values to show in each cell. Not configurable by now.
    frequencyValuesDefault: ['frequency', 'normalized'],
    // Values to show in each cell
    frequencyValues: ['frequency'],
    // Columns to show (grouped frequencies)
    frequencyGroups: []
  },
  mutations: {
    setFrequencyGroups: function setFrequencyGroups(s, g) {
      s.frequencyGroups = clone(g);
    },
    setFrequencyGroupValues: function setFrequencyGroupValues(s, _ref) {
      var group = _ref.group,
          values = _ref.values;
      s.frequencyGroups = _objectSpread({}, s.frequencyGroups, _defineProperty({}, group, values));
    },
    setFrequencyValues: function setFrequencyValues(s, v) {
      s.frequencyValues = intersection(v, s.frequencyValuesDefault); // Only valid values
    },
    restoreSnapshot: function restoreSnapshot(s, v) {
      s.frequencyValues = v.frequencyValues;
      s.frequencyGroups = v.frequencyGroups;
    }
  },
  getters: {
    snapshot: function snapshot(s) {
      return s;
    },
    query: function query(s) {
      return s.frequencyGroups;
    },
    options: function options(s, g, rs, rg) {
      var formResultType = rg['api/formResultType'];
      var elementType = rs.elements.type;
      return get(Ncs.config.result, [formResultType, elementType, 'groups'], []);
    }
  },
  actions: {
    setFrequencyGroupValues: function setFrequencyGroupValues(_ref2, groupValues) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters,
          rootState = _ref2.rootState;
      commit('setFrequencyGroupValues', groupValues);
      dispatch('history/push', null, {
        root: true
      });
    },
    setDefault: function setDefault(_ref3) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          getters = _ref3.getters,
          rootGetters = _ref3.rootGetters,
          rootState = _ref3.rootState;
      var formResultType = rootGetters['api/formResultType'];
      var allGroups = get(Ncs.config.result, [formResultType, 'frequency_group_values'], {});
      var defaultGroups = get(Ncs.config.result, [formResultType, 'default_frequency_groups'], keys(allGroups));
      var selectedGroups = pick(allGroups, defaultGroups);
      commit('setFrequencyValues', ['frequency']);
      commit('setFrequencyGroups', selectedGroups);
    },
    reset: function reset(_ref4) {
      var state = _ref4.state,
          dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          getters = _ref4.getters,
          rootGetters = _ref4.rootGetters,
          rootState = _ref4.rootState;
      dispatch('setDefault');
    }
  }
};